import axios from "axios";

const API_URL = window._config.API_BASEURL

const apiClient = axios.create({
    baseURL: API_URL,
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json'
    }
})

export default apiClient
